import {Text} from '@rdcomponents/text/text';
import {Flex, Tag} from 'antd';

import {ReviewAdditionalDataType} from '../../../../../../../service/reviews/reviews-type';

import {getReviewAdditionalDataTagLabels} from './review-additional-data-helper';
import * as styles from './review-additional-data-tags.scss';

type PropsType = {
    additionalData?: ReviewAdditionalDataType | null;
};

export function ReviewAdditionalDataTags(props: PropsType): JSX.Element | null {
    const {additionalData} = props;
    const labels = getReviewAdditionalDataTagLabels(additionalData);

    if (labels.length === 0) {
        return null;
    }

    return (
        <Flex gap={8} wrap="wrap">
            {labels.map((label) => (
                <Tag className={styles.ReviewAdditionalDataTags_tag} key={label}>
                    <Text lighter small>
                        {label}
                    </Text>
                </Tag>
            ))}
        </Flex>
    );
}
